import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Badge from 'flarum/components/Badge';
import User from 'flarum/models/User';

export default () => {
    subscriber_icon();
}

function subscriber_icon() {
    extend(User.prototype, 'badges', function (items) {
        if (this.isSubscribed()) {
            items.add(
                'subscriber',
                <Badge icon="fab fa-phoenix-squadron" type="subscriber" label={ app.translator.trans('xtreh-phoenix.forum.user_badge.subscriber_tooltip') } />
            );
        }
    });
}
